import styled, { css } from 'styled-components'

export interface PlotPopupContainerProps {
  $active?: boolean
  $x?: number
  $y?: number
}

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<PlotPopupContainerProps>`
  position: absolute;
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  padding: 12px;
  min-width: 200px;
  pointer-events: none;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 40;

  ${({ $x, $y }) =>
    $x !== undefined &&
    $y !== undefined &&
    css`
      left: ${$x}px;
      top: ${$y}px;
    `}

  ${({ $active }) =>
    $active &&
    css`
      opacity: 1;
      transform: translateY(0);
    `}
`

export const PlotHeader = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 8px;
`

export const PlotInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const PlotRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
`

export const PlotLabel = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const PlotValue = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 500;
`
